import IqosXDiploma from "./IqosXDiploma";
export default IqosXDiploma;